import { Content } from '../../types';

export const watSaketContent: Content = {
  title: 'מקדש Golden Mount (Wat Saket) בבנגקוק, תאילנד',
  imageUrl: '/images/thailand/wat-saket/wat-saket-wide.jpeg',
  introduction: `מקדש Golden Mount, הידוע גם בשם וואט סאקט (Wat Saket), הינו אחד מהאתרים הדתיים המפורסמים ביותר בבנגקוק. הוא מתנשא מעל העיר ומציע חוויית ביקור ייחודית הכוללת היסטוריה עשירה, אווירה רוחנית ותצפית פנורמית עוצרת נשימה על המטרופולין התוסס של תאילנד.`,
  sections: [
    {
      title: 'היסטוריה ומקור השם',
      content: `מקדש וואט סאקט נבנה בתקופת ממלכת איוטהאיה, אך זכה לשיפוץ ולהרחבה משמעותית במהלך שלטונו של המלך ראמה השלישי במאה ה-19. המלך ניסה לבנות סטופה (מבנה בודהיסטי מקודש) ענקית, אך הקרקע הביצתית של בנגקוק לא יכלה לתמוך במשקל, והמבנה קרס. מאוחר יותר, בתקופתו של המלך ראמה הרביעי, נבנתה סטופה חדשה על גבי הר מלאכותי שנוצר מחורבות הבנייה הקודמת. כיפת הזהב המבריקה היא שנתנה למקום את שמו - "הר הזהב" Golden Mount.`,
      type: 'text',
    },
    {
      title: 'ייחודיות המקדש',
      content: `מה שהופך את Golden Mount למיוחד הינו מיקומו הגבוה, המעניק לו תחושת ניתוק מהרעש וההמולה של העיר הסואנת. כדי להגיע לפסגת ההר, יש לטפס כ - 318 מדרגות, כשלאורכן פזורים פעמוני תפילה, פסלי בודהה ומפלים קטנים היוצרים אווירה שלווה ומדיטטיבית. בפסגת המקדש נמצאת הסטופה המוזהבת המכילה על פי המסורת שריד קדוש של הבודהה, מה שהופך את המקום לאתר עליה לרגל חשוב עבור מאמינים בודהיסטים.<br />

אווירה מדיטטיבית הינה אווירה אשר משרה רוגע, שלווה וריכוז, כמו זו שמאפיינת תרגולי מדיטציה. היא יכולה לבוא לידי ביטוי בשקט, בתאורה רכה, בצלילים עדינים (כגון פעמונים או מים זורמים) ובנוף טבעי או רוחני שמסייעים לאדם להירגע ולהתמקד. במקדש Golden Mount, לדוגמא, הצלילים של פעמוני התפילה, הרוח הנעימה והמקדש הגבוה שמנותק מהמולת העיר יוצרים תחושה כזו.`,
      type: 'text',
    },
    {
      title: 'אירועים מיוחדים',
      content: `Golden Mount מהווה מוקד לפסטיבלים דתיים חשובים, במיוחד במהלך חג לוי קאטונג Loy Krathong המתקיים בחודש נובמבר. בזמן החג, המקדש מואר באלפי פנסים צבעוניים והמוני מתפללים מגיעים להדליק נרות ולשחרר סירות קטנות עשויות מעלי בננה לנהר. זהו מחזה קסום שמושך אליו מקומיים ותיירים כאחד.`,
      type: 'text',
    },
    {
      title: 'התצפית מהפסגה',
      content: `אחד ההיבטים המרשימים ביותר של הביקור במקדש הוא הנוף המרהיב הנשקף ממנו. מהפסגה ניתן לראות את קו הרקיע של בנגקוק, את נהר הצ'או פראיה ואתרים חשובים נוספים כגון מקדש וואט סותאט ומונומנט הדמוקרטיה. בשעות הערב, בעת שהשמש שוקעת, המקום הופך לרומנטי במיוחד.`,
      type: 'text',
    },
    {
      title: 'דרכי הגעה',
      type: 'sub-headers',
      description:
        'המקדש ממוקם ברובע פומ פראב (Pom Prap Sattru Phai), לא רחוק מרחוב הקאוסאן. ניתן להגיע אליו בדרכים הבאות:',
      content: [
        {
          subtitle: 'מונית או טוק-טוק',
          text: 'דרך נוחה ומהירה לביקור, במיוחד אם נמצאים במרכז העיר.',
        },
        {
          subtitle: 'סירה על תעלת סאהן סאפ',
          text: 'ניתן לקחת סירת אקספרס ולעצור בתחנת "פאן פה" (Panfa Leelard Pier), שנמצאת במרחק קצר מהמקדש.',
        },
        {
          subtitle: 'אוטובוסים מקומיים',
          text: 'קווים שונים של אוטובוסים ציבוריים מגיעים לאזור.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content: `בשורה התחתונה, ביקור ב - Golden Mount הינו חוויה בלתי נשכחת למבקרים בבנגקוק. השילוב של היסטוריה מרתקת, אווירה רוחנית, נופים מדהימים ואירועים מסורתיים הופכים אותו לאחד מהמקומות המומלצים ביותר בעיר. בין אם הינכם חובבי תרבות, היסטוריה או פשוט מחפשים מקום שקט עם נוף מדהים - Golden Mount הינו יעד שאסור לפספס.`,
      type: 'text',
      isBold: true,
    },
  ],
};
